export const SaleBanner = () => {
  return (
    <section id="Section 6">
      <div className="sale-banner" >
        <div className="banner__content">
          <div className="txt">
            <div className="btn-white">
              <a href="https://www.lippioutdoor.com/navidad-2022/camping.html" target='_parent' id='btn-banner-five-1'>Camping</a>
            </div>
            <h2>La mejor época para salir a acampar.</h2>
          </div>
        </div>
      </div>
    </section>
  )
}